import CustomWrapper from "components/Chakra/CustomWrapper";
import Tabs from "components/Tabs";
import { GridLayout } from "components/Chakra/GridLayout";
import { firstTabItems } from "./TabContent/FirstTab";
import { secondTabItems } from "./TabContent/SecondTab";
import { thirdTabItems } from "./TabContent/ThirdTab";
import IconCamera from "components/Chakra/Icons/Camera";
import IconCam2 from "components/Chakra/Icons/Cam2";
import IconRuler from "components/Chakra/Icons/Ruler";

const listTabs = [
  {
    tab: {
      text: "Fotografie",
      icon: <IconCamera boxSize="18px" />,
    },
    title: "Váš byt v nejlepším světle",
    content: (
      <GridLayout
        templateAreas={{
          base: "none",
          md: `
            "A A B B B"
            "C C B B B"
            "D D D E E"
            "D D D E E"
          `,
        }}
        templateRows={{
          base: "none",
          md: "repeat(4, 1fr)",
        }}
        templateColumns={{
          base: "none",
          md: "repeat(5, 1fr)",
        }}
        items={firstTabItems}
        isZoomIn
      />
    ),
  },
  {
    tab: {
      text: "3D Scan",
      icon: <IconCam2 boxSize="18px" />,
    },
    title: "Váš byt v nejlepším světle",
    content: (
      <GridLayout
        templateAreas={{
          base: "none",
          md: `
      "A B B"
      "A B B"
      "A B B"
    `,
        }}
        templateRows={{
          base: "none",
          md: "repeat(2, 1fr)",
        }}
        templateColumns={{
          base: "none",
          md: "440px 1fr",
        }}
        items={secondTabItems}
      />
    ),
  },
  // {
  //   tab: {
  //     text: "Video",
  //     icon: <IconHouse boxSize="18px" />,
  //   },
  //   title: "Váš byt v nejlepším světle",
  //   content: (
  //     <GridLayout
  //       templateAreas={{
  //         base: "none",
  //         md: `
  //         "A B B"
  //         "A B B"
  //         "A B B"
  //   `,
  //       }}
  //       templateRows={{
  //         base: "none",
  //         md: "repeat(2, 1fr)",
  //       }}
  //       templateColumns={{
  //         base: "none",
  //         md: "440px 1fr",
  //       }}
  //       items={thirdTabItems}
  //     />
  //   ),
  // },
  {
    tab: {
      text: "Půdorys",
      icon: <IconRuler boxSize="18px" />,
    },
    title: "Váš byt v nejlepším světle",
    content: (
      <GridLayout
        templateAreas={{
          base: "none",
          md: `
          "A B B"
          "A B B"
          "A B B"
    `,
        }}
        templateRows={{
          base: "none",
          md: "repeat(2, 1fr)",
        }}
        templateColumns={{
          base: "none",
          md: "440px 1fr",
        }}
        items={thirdTabItems}
        isZoomIn
      />
    ),
  },
];

const TabsWrapper = () => (
  <CustomWrapper
    maxW="1360px"
    contentProps={{
      m: { base: "80px 0 100px", md: "80px 0 120px" },
    }}
  >
    <Tabs listTabs={listTabs} sameTitleTop="Váš byt v nejlepším světle" />
  </CustomWrapper>
);

export default TabsWrapper;
